import axios from '../http.js'

//新增试卷
function addPaper(data) {
  return axios.baseAxios({
    url: '/backstage/testPaper/createTestPaper',
    method: 'post',
    data: data
  })
}
//试卷详情
function getPaperDetail(data) {
  return axios.baseAxios({
    url: '/backstage/testPaper/queryTestPaperDetail',
    method: 'post',
    params: data
  })
}

//试卷列表
function getPaperList(data) {
  return axios.baseAxios({
    url: '/backstage/testPaper/queryTestPaperPage',
    method: 'post',
    data: data
  })
}
//查询随机抽题可用试题数量
function getQuestionNum(data) {
  return axios.baseAxios({
    url: '/backstage/testPaper/queryRandomQuestionAvailableQuestionNum',
    method: 'post',
    data: data
  })
}
//删除试卷
function delPaper(data) {
  return axios.baseAxios({
    url: '/backstage/testPaper/deleteTestPaper',
    method: 'post',
    params: data
  })
}
//编辑试卷
function editPaper(data) {
  return axios.baseAxios({
    url: '/backstage/testPaper/editTestPaper',
    method: 'post',
    data: data
  })
}
//复制试卷
function copyPaper(data) {
  return axios.baseAxios({
    url: '/backstage/testPaper/copyTestPaper',
    method: 'post',
    params: data
  })
}
//查询试卷引用的考试列表
function queryTestPaperBindExamPage(data) {
  return axios.baseAxios({
    url: '/backstage/testPaper/queryTestPaperBindExamPage',
    method: 'post',
    data: data
  })
}


export default {
  addPaper,
  getPaperDetail,
  getPaperList,
  getQuestionNum,
  delPaper,
  editPaper,
  copyPaper,
  queryTestPaperBindExamPage
}


// WEBPACK FOOTER //
// ./src/api/modules/paper.js